import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import { useSelector } from 'react-redux'
import logo from '../Images/logo.png'

export default function Header() {
        const paymentData = useSelector((state) => state.customerData)

    return (
        <Box>
            <AppBar
                position="static"
                sx={{
                    paddingBottom: 2,
                    paddingTop: 2,
                    backgroundColor: 'white',
                    color: 'black',
                }}
            >
                <img
                    src={paymentData.customerData.UIConfig.LogoURI||logo}
                    style={{ width: '150px', alignSelf: 'center' }}
                />
            </AppBar>
        </Box>
    )
}
